var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLuggageCompartmentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2727 4.77091H19.3309V9.89091H20.8582V4.77091H24.2327V9.89091H25.7454V4.77091H25.8036C26.2254 4.77091 26.56 4.43636 26.56 4.01454C26.56 3.59272 26.2254 3.25818 25.8036 3.25818H19.2727C18.8509 3.25818 18.5164 3.59272 18.5164 4.01454C18.5164 4.43636 18.8509 4.77091 19.2727 4.77091Z",
    fill: "#C0C8D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6182 10.8945H18.4582C17.1345 10.8945 16.0582 11.9709 16.0582 13.2945V15.9127H16.8145C18.9818 15.9127 20.7418 17.6727 20.7418 19.84V26.3709C20.7418 27.2727 20.4364 28.1018 19.9273 28.7709H26.6182C27.9418 28.7709 29.0182 27.6945 29.0182 26.3709V13.28C29.0036 11.9709 27.9418 10.8945 26.6182 10.8945Z",
    fill: "#C0C8D7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.41092 14.2836H12.7855V16.0291H14.3127V13.5272C14.3127 13.1054 13.9782 12.7709 13.5564 12.7709H8.65456C8.23274 12.7709 7.89819 13.1054 7.89819 13.5272V16.0291H9.42547V14.2836H9.41092Z",
    fill: "#C0C8D7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.12 17.4255H16.8145H16.7127H15.1854H7.0109H5.49817H5.38181H5.07636C3.92727 17.4255 2.98181 18.3564 2.98181 19.5201V19.8255V19.9274V21.4546V24.7274V26.2546V26.3564V26.6619C2.98181 27.811 3.91272 28.7564 5.07636 28.7564H5.38181H5.48363H7.0109H15.1709H16.6982H16.8H17.1054C18.2545 28.7564 19.2 27.8255 19.2 26.6619V26.3564V26.2546V19.5201C19.2145 18.3564 18.2836 17.4255 17.12 17.4255Z",
    fill: "#C0C8D7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuggageCompartmentIcon);
export default __webpack_public_path__ + "static/media/luggage_compartment_icon.2d8433287fd81bf8ba75b900df35c355.svg";
export { ForwardRef as ReactComponent };